exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".subscription-confirm{width:460px}", "", {"version":3,"sources":["/divvit-app/client/modals/CancelSubscriptionConfirm/client/modals/CancelSubscriptionConfirm/style.styl","/divvit-app/client/modals/CancelSubscriptionConfirm/style.styl"],"names":[],"mappings":"AAAA,sBACE,WAAA,CCCD","file":"style.styl","sourcesContent":[".subscription-confirm\n  width: 460px\n",".subscription-confirm {\n  width: 460px;\n}\n/*# sourceMappingURL=client/modals/CancelSubscriptionConfirm/style.css.map */"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??postcss!./node_modules/stylus-loader??ref--3-3!./client/modals/CancelSubscriptionConfirm/style.styl
// module id = 525
// module chunks = 0